import { Divider } from '@mui/material';

import { Avatar } from '../../features/ProfileEdit/Avatar';
import { DisplayPicture } from '../../features/ProfileEdit/DisplayPicture/DisplayPicture';
import { ProfilePictureStyled } from './ProfilePictureStyled';

interface ProfileUploadSectionProps {
  orientationDivider: 'horizontal' | 'vertical';
  scope: 'family' | 'subscriber';
  avatarFamilyDrawerScrollRef: any;
}

export const ProfileUploadSection = ({
  orientationDivider,
  scope,
  avatarFamilyDrawerScrollRef,
}: ProfileUploadSectionProps) => {
  const familyContainerWidth = document.querySelector(
    '#enrollment-family-container'
  ) as HTMLElement;

  return (
    <>
      <DisplayPicture
        scope={scope}
        avatarFamilyDrawerScrollRef={avatarFamilyDrawerScrollRef}
      />
      <Divider orientation={orientationDivider} flexItem aria-hidden="true" />
      <ProfilePictureStyled familycontainerwidth={familyContainerWidth}>
        <Avatar scope={scope} />
      </ProfilePictureStyled>
    </>
  );
};
